/**
 * Brand asset URLs — the SAME pattern as template snapshots (SNAP):
 * one canonical copy lives in fitcraft_designer_site/static/brand/ which the
 * existing deploy pipeline syncs to CloudFront. Locally the Django dev server
 * serves /static/ from that dir; in production the CDN serves it.
 *
 * Use these everywhere instead of bundled imports or public/ copies, so a
 * fresh logo/favicon only ever needs ONE upload (static -> CDN) to go live.
 */
const _isLocal =
  typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)/.test(window.location.hostname);

// The CDN serves the static/ folder's CONTENTS at its ROOT — /brand/…,
// NOT /static/brand/… — so the prod base has no /static prefix.
export const BRAND_STATIC = _isLocal
  ? '/static/brand'
  : 'https://d3qvi06vol9hrb.cloudfront.net/brand';

export const INIKRU_LOGO = `${BRAND_STATIC}/inikru-logo.png`;
export const INIKRU_LOGO_WHITE = `${BRAND_STATIC}/inikru-logo-white.png`;
export const INIKRU_MARK = `${BRAND_STATIC}/inikru-mark.png`;
export const INIKRU_MARK_64 = `${BRAND_STATIC}/inikru-mark-64.png`;
export const INIKRU_PRIMARY = `${BRAND_STATIC}/inikru-primary.png`;

// Template snapshots live in the same static dir — same local-vs-CDN rule.
export const STATIC_BASE = _isLocal
  ? '/static'
  : 'https://d3qvi06vol9hrb.cloudfront.net';
export const SNAP = (id) =>
  `${STATIC_BASE}/template_snapshots/t${String(id).padStart(2, '0')}.jpg`;
